// Arabic strings for the device side of module 18 (ADR-025). Development draft, unreviewed (PD-011, H-10).
import type { enAdapters } from './en-adapters.ts';

export const arAdapters: Record<keyof typeof enAdapters, string> = {
  'adp.api.signingUnavailable': 'لم يُضبط توقيع أوامر الوكيل الطرفي في هذا النشر، لذا لا يمكن إرسال أي أمر.',
  'adp.api.agentUnavailable': 'هذا الوكيل الطرفي غير نشط.',
  'adp.api.peripheralNotAllowed': 'اسمح بهذا الجهاز على وكيله الطرفي أولاً.',
  'adp.api.notEnrolled': 'لم يسجّل هذا الوكيل الطرفي مفتاحه بعد.',
  'adp.api.alreadyEnrolled': 'هذا الوكيل الطرفي مسجّل بمفتاح آخر. ألغِه وأعد إقرانه لاستبداله.',
  'adp.api.replayed': 'استُخدم هذا الطلب أو الأمر من قبل، لذا رُفض.',
  'adp.api.nonceMismatch': 'مرجع الأمر غير مطابق.',
  'adp.api.commandExpired': 'انتهت صلاحية هذا الأمر.',
  'adp.api.commandNotCancellable': 'لا يمكن إلغاء إلا أمر لم يؤكد أي وكيل استلامه.',
  'adp.api.notPushSource': 'المصادر ذات الإرسال الموقّع وحدها لها سرّ.',
  'adp.api.sourceDisabled': 'مصدر قراءة اللوحات هذا معطّل.',
  'adp.api.anprEntitlement': 'خدمة التعرّف على اللوحات غير مفعّلة لمؤسستك.',
  'adp.api.printJobSettled': 'مهمة الطباعة هذه لها نتيجة أو مهمة جهاز بالفعل.',
  'adp.api.cardNotEncodable': 'لا يمكن ترميز إلا بطاقة متاحة أو مسلّمة.',
  'adp.api.cardOnHold': 'لهذه البطاقة ترميز لم تُعرف نتيجته. اقرأها مجدداً أو سجّل الفحص اليدوي أولاً.',
  'adp.api.cardJobOpen': 'لهذه البطاقة مهمة جهاز قيد التنفيذ.',
  'adp.api.holdReleased': 'رُفع هذا الحجز من قبل.',
  'adp.api.updateWithdrawn': 'سُحب هذا التحديث من قبل.',
  'adp.v.wrongSite': 'هذا الجهاز يتبع موقعاً آخر.',
  'adp.v.peripheralUnknown': 'اختر جهازاً متصلاً بوكيل طرفي.',
  'adp.v.capabilityMismatch': 'لا يستطيع هذا الجهاز القيام بذلك.',
  'adp.v.agentUnknown': 'اختر وكيلاً طرفياً مسجّلاً.',
  'adp.v.agentForRelay': 'مصدر الترحيل الطرفي يحتاج إلى وكيله، ولا يكون الوكيل إلا لمصدر ترحيل.',
  'adp.v.sourceRefTaken': 'مرجع المصدر هذا مستخدم في هذا الموقع.',
  'adp.v.notContractTestable': 'ليس لهذا المحوّل هدف اختبار عقد داخلي.',
  'adp.v.versionPublished': 'هذا الإصدار منشور على هذه القناة بالفعل.',
  'adp.reject.duplicate_card': 'نظام التحكم في الدخول يحتفظ بهذه البطاقة لشخص آخر. استخدم بطاقة أخرى أو أزل التكرار هناك.',
  'adp.reject.schedule_unsupported': 'لا يستطيع نظام التحكم في الدخول حفظ هذا الجدول. استخدم نافذة متصلة أو ضيّق الزيارة.',
  'adp.reject.zone_unknown': 'نظام التحكم في الدخول لا يعرف منطقة مربوطة. راجع ربط المناطق.',
  'adp.reject.card_unknown': 'نظام التحكم في الدخول لا يعرف هذه البطاقة. سجّلها هناك أولاً.',
  'adp.reject.token_type_unsupported': 'نظام التحكم في الدخول لا يدعم نوع بيانات الاعتماد هذا.',
  'adp.limit.untestedWithVendor': 'قائم على معيار، ومختبر فقط مقابل محاكٍ محلي. لم يُعتمد مع أي نظام مورّد.',
  'adp.limit.profileRequired': 'يجب أن يطبّق جانب التحكم في الدخول ملف passage-access-rest/1.',
  'adp.limit.noProduction': 'غير مسموح في بيئة الإنتاج حتى يعتمد المالك منصة وإصداراً محددين.',
  'adp.limit.noEntryCommands': 'قراءات اللوحات ملاحظات فقط؛ لا تفتح حاجزاً ولا تقرر الدخول.',
  'adp.limit.simulatorOnly': 'محاكٍ للتطوير والاختبار فقط.',
  'adp.limit.unavailable': 'غير متاح: لا يوجد محوّل ولم يجتز أي اختبار توافق.',
  // ------------------------------------------------------------ UI (apps/web/src/pages/IntegrationsDevices.tsx)
  'ig.tab.edge': 'الوكلاء الطرفيون والمهام',
  'ig.tab.anpr': 'مصادر قراءة اللوحات',
  'ig.tab.catalogue': 'دليل المحوّلات',
  'adp.ui.secretTitle': 'سرّ إرسال قراءات اللوحات',
  'adp.ui.edge.title': 'الوكلاء الطرفيون',
  'adp.ui.edge.intro': 'وكلاء محليون يشغّلون الطابعات وأجهزة الترميز والقارئات التي لا يستطيع المتصفح تشغيلها. يظهر الاتصال منفصلاً عن نتائج المهام.',
  'adp.ui.edge.empty': 'لا يوجد وكيل طرفي مقترن. اقرن وكيلاً من تبويب الأجهزة بالنوع "وكيل طرفي".',
  'adp.ui.edge.agent': 'الوكيل',
  'adp.ui.edge.commands': 'الأوامر',
  'adp.ui.edge.buffer': 'المخزن دون اتصال',
  'adp.ui.edge.fingerprint': 'المفتاح',
  'adp.ui.edge.pending': '{count} قيد الانتظار',
  'adp.ui.edge.unknownCount': '{count} بنتيجة غير معروفة',
  'adp.ui.edge.depth': '{count} مخزّنة',
  'adp.ui.edge.dropped': '{count} رُفضت لامتلاء المخزن',
  'adp.ui.edge.detailHint': 'الأجهزة المسموح بها والأوامر الموقّعة وقناة التحديث.',
  'adp.ui.edge.rotated': 'بُدّل في {at}',
  'adp.ui.edge.version': 'إصدار الوكيل',
  'adp.ui.edge.update': 'قناة التحديث',
  'adp.ui.edge.updateAvailable': 'الإصدار {version} متاح وتحقق توقيعه. ثبّته محلياً.',
  'adp.ui.edge.updateCurrent': 'محدّث (أحدث إصدار موقّع {version}).',
  'adp.ui.edge.updateUnverified': 'عُرض الإصدار {version} لكن توقيعه لم يتحقق. لن يُثبّت شيء.',
  'adp.ui.edge.updateNone': 'لم يُفحص أي تحديث بعد.',
  'adp.ui.edge.peripherals': 'الأجهزة المتصلة',
  'adp.ui.edge.peripheralsHint': 'الجهاز الذي يبلّغ عنه الوكيل لا يفعل شيئاً حتى يسمح به شخص. البرنامج الثابت غير المدرج في قائمة معتمدة يوسم بأنه غير معتمد.',
  'adp.ui.edge.firmwareValidated': 'برنامج ثابت معتمد',
  'adp.ui.edge.firmwareUnvalidated': 'برنامج ثابت غير معتمد',
  'adp.ui.edge.allow': 'السماح',
  'adp.ui.edge.block': 'الحظر',
  'adp.ui.edge.testPrint': 'طباعة صفحة اختبار',
  'adp.ui.edge.ping': 'إرسال أمر اختبار',
  'adp.ui.edge.commandLog': 'الأوامر الموقّعة الأخيرة',
  'adp.ui.edge.commandHint': 'كل أمر موقّع وتنتهي صلاحيته ويُنفّذ مرة واحدة. الأمر الذي لم يؤكده الجهاز يبقى غير معروف النتيجة.',
  'adp.ui.edge.late': 'أُبلغ عنه متأخراً',
  'adp.ui.jobs.title': 'مهام الأجهزة',
  'adp.ui.jobs.intro': 'مهام الطباعة والترميز وقراءة الهوية ونتائجها الخاصة. الجهاز المتصل لا يعني نجاح المهمة.',
  'adp.ui.jobs.empty': 'لا توجد مهام أجهزة بعد.',
  'adp.ui.jobs.job': 'المهمة',
  'adp.ui.jobs.outcome': 'النتيجة',
  'adp.ui.jobs.when': 'وقت الطلب',
  'adp.ui.jobs.held': 'البطاقة محجوزة',
  'adp.ui.holds.title': 'البطاقات المحجوزة',
  'adp.ui.holds.intro': 'البطاقة التي لم تُعرف نتيجة ترميزها لا يعاد استخدامها حتى تُقرأ مجدداً أو تُفحص يدوياً.',
  'adp.ui.holds.empty': 'لا توجد بطاقة محجوزة.',
  'adp.ui.holds.manual': 'تسجيل فحص يدوي',
  'adp.ui.holds.manualHint': 'فقط بعد فحص البطاقة أو مسحها في جهاز الترميز. يُسجّل ذلك باسمك.',
  'adp.ui.holds.note': 'ما الذي فُحص',
  'adp.ui.holds.release': 'رفع الحجز عن البطاقة',
  'adp.ui.updates.title': 'تحديثات الوكيل',
  'adp.ui.updates.intro': 'بيانات إصدار موقّعة. يتحقق الوكلاء من التوقيع وبصمة الملف؛ لا يُنزّل أو يُثبّت شيء تلقائياً.',
  'adp.ui.updates.key': 'موقّع بالمفتاح {key}.',
  'adp.ui.updates.noKey': 'لم يُضبط مفتاح توقيع في هذا النشر.',
  'adp.ui.updates.empty': 'لم يُنشر أي تحديث.',
  'adp.ui.updates.channel': 'القناة',
  'adp.ui.updates.version': 'الإصدار',
  'adp.ui.updates.sha': 'بصمة SHA-256 للنسخة',
  'adp.ui.updates.size': 'الحجم بالبايت',
  'adp.ui.updates.publish': 'نشر بيان موقّع',
  'adp.ui.anpr.title': 'مصادر قراءة اللوحات',
  'adp.ui.anpr.intro': 'أنظمة الكاميرات تغذي مراجعة البوابة بقراءات اللوحات. القراءات غير الواضحة أو منخفضة الثقة أو ذات الساعة المنحرفة تذهب إلى الحارس.',
  'adp.ui.anpr.empty': 'لا يوجد مصدر قراءة لوحات بعد.',
  'adp.ui.anpr.source': 'المصدر',
  'adp.ui.anpr.transport': 'الاتصال',
  'adp.ui.anpr.last24': 'آخر 24 ساعة',
  'adp.ui.anpr.secretHint': 'سرّ ينتهي بـ {hint}',
  'adp.ui.anpr.stats': '{recorded} مسجّلة · {duplicates} مكررة · {rejected} مرفوضة',
  'adp.ui.anpr.skewed': '{count} بانحراف في ساعة الكاميرا',
  'adp.ui.anpr.events': 'الأحداث الأخيرة',
  'adp.ui.anpr.add': 'إضافة مصدر قراءة لوحات',
  'adp.ui.anpr.addHint': 'مصدر الإرسال الموقّع يحصل على سرّ يُعرض مرة واحدة. مصدر الترحيل يرتبط بوكيل طرفي واحد.',
  'adp.ui.anpr.name': 'الاسم',
  'adp.ui.anpr.ref': 'مرجع المصدر',
  'adp.ui.anpr.refHint': 'أحرف لاتينية صغيرة وأرقام ونقاط وشرطات. يميّز أنظمة الكاميرات.',
  'adp.ui.anpr.agent': 'معرّف الوكيل الطرفي',
  'adp.ui.anpr.scale': 'مقياس الثقة',
  'adp.ui.anpr.skew': 'التسامح مع انحراف الساعة (ثوانٍ)',
  'adp.ui.anpr.skewHint': 'القراءات من ساعة كاميرا منحرفة أكثر من ذلك توسم ولا تُحتسب مطابقة واثقة أبداً.',
  'adp.ui.anpr.create': 'إضافة المصدر',
  'adp.ui.anpr.eventsHint': 'بيانات التوجيه فقط. يظهر نص اللوحة في مساحة عمل البوابة.',
  'adp.ui.anpr.noEvents': 'لا توجد أحداث بعد.',
  'adp.ui.anpr.skewFlag': 'انحراف الساعة {seconds} ث',
  'adp.ui.anpr.lateFlag': 'متأخرة',
  'adp.ui.cat.title': 'دليل المحوّلات',
  'adp.ui.cat.intro': 'كل محوّل وإصداره وما يستطيعه ومدى اختباره.',
  'adp.ui.cat.noVendor': 'لا يوجد نظام مورّد معتمد. تبقى المنصات المسماة غير متاحة حتى يختار المالك إحداها وتنجح اختبارات توافقها.',
  'adp.ui.cat.adapter': 'المحوّل',
  'adp.ui.cat.status': 'الاعتماد',
  'adp.ui.cat.capabilities': 'العمليات والقدرات',
  'adp.ui.cat.contract': 'اختبارات العقد',
  'adp.ui.cat.validatedVersions': 'الإصدارات المعتمدة: {versions}',
  'adp.ui.cat.none': 'لا شيء',
  'adp.ui.cat.lastRun': '{passed} ناجحة، {failed} فاشلة',
  'adp.ui.cat.neverRun': 'لم تُشغّل بعد',
  'adp.ui.cat.run': 'تشغيل اختبارات العقد',
  'adp.ui.cat.resultTitle': 'اختبارات العقد: {adapter}',
  'adp.ui.cat.targetFake': 'شُغّلت داخلياً مقابل محاكٍ محلي. ليست اختباراً مقابل أي نظام مورّد.',
  'adp.ui.cat.targetSimulator': 'شُغّلت داخلياً مقابل المحاكي.',
  'adp.ui.cat.passed': 'ناجح',
  'adp.ui.cat.failed': 'فاشل',
  'adp.validation.simulator': 'محاكٍ فقط',
  'adp.validation.standards-based-untested-with-vendor': 'قائم على معيار، غير مختبر مع أي مورّد',
  'adp.validation.unavailable': 'غير متاح',
  'adp.periph.pending': 'بانتظار قرار',
  'adp.periph.allowed': 'مسموح',
  'adp.periph.blocked': 'محظور',
  'adp.kind.printer': 'طابعة الشارات',
  'adp.kind.encoder': 'جهاز ترميز البطاقات',
  'adp.kind.id_reader': 'قارئ الهوية الإماراتية',
  'adp.kind.mrz_reader': 'قارئ منطقة القراءة الآلية',
  'adp.kind.anpr_camera': 'كاميرا قراءة اللوحات',
  'adp.kind.osdp_reader': 'قارئ باب (OSDP)',
  'adp.kindAdapter.access_control': 'التحكم في الدخول',
  'adp.kindAdapter.anpr': 'قراءة اللوحات',
  'adp.kindAdapter.reader': 'قارئ الهوية',
  'adp.kindAdapter.printer': 'طابعة',
  'adp.kindAdapter.encoder': 'جهاز ترميز البطاقات',
  'adp.cmd.diagnostic.ping': 'أمر اختبار',
  'adp.cmd.printer.test': 'صفحة اختبار',
  'adp.cmd.print.badge': 'طباعة شارة',
  'adp.cmd.encode.card': 'ترميز بطاقة',
  'adp.cmd.encode.read_back': 'إعادة قراءة البطاقة',
  'adp.cmd.reader.capture': 'قراءة وثيقة هوية',
  'adp.cmdStatus.issued': 'بانتظار الوكيل',
  'adp.cmdStatus.acknowledged': 'استلمه الوكيل',
  'adp.cmdStatus.completed': 'اكتمل',
  'adp.cmdStatus.failed': 'فشل',
  'adp.cmdStatus.unknown': 'النتيجة غير معروفة',
  'adp.cmdStatus.rejected_by_agent': 'رفضه الوكيل',
  'adp.cmdStatus.expired': 'انتهت صلاحيته قبل التسليم',
  'adp.cmdStatus.cancelled': 'أُلغي',
  'adp.job.print': 'طباعة شارة',
  'adp.job.encode': 'ترميز بطاقة',
  'adp.job.encode_read_back': 'إعادة قراءة بطاقة',
  'adp.job.read_identity': 'قراءة وثيقة هوية',
  'adp.jobStatus.queued': 'في الانتظار',
  'adp.jobStatus.sent': 'أُرسلت إلى الجهاز',
  'adp.jobStatus.printed': 'طُبعت',
  'adp.jobStatus.encoded': 'رُمّزت',
  'adp.jobStatus.read': 'قُرئت',
  'adp.jobStatus.failed': 'فشلت',
  'adp.jobStatus.unknown': 'النتيجة غير معروفة',
  'adp.jobStatus.cancelled': 'أُلغيت',
  'adp.reason.not_delivered': 'لم يُسلّم قبل انتهاء صلاحيته؛ لم يُنفّذ شيء.',
  'adp.reason.no_result_before_deadline': 'لم يؤكد الجهاز في الوقت المحدد.',
  'adp.reason.device_confirmed': 'أكده الجهاز.',
  'adp.reason.device_failed': 'أبلغ الجهاز عن فشل.',
  'adp.reason.device_unconfirmed': 'لم يؤكد الجهاز.',
  'adp.reason.rejected_by_agent': 'رفض الوكيل الأمر.',
  'adp.reason.reader_output_invalid': 'تعذّر استخدام مخرجات القارئ.',
  'adp.reason.cancelled_by_operator': 'ألغاه مشغّل.',
  'adp.reason.invalid_payload': 'لم يكن الحدث بالصيغة المتوقعة.',
  'adp.reason.source_not_bound_to_agent': 'لا يجوز لهذا الوكيل الترحيل لهذا المصدر.',
  'adp.reason.read_back_blank': 'إعادة القراءة: البطاقة فارغة.',
  'adp.reason.read_back_encoded': 'إعادة القراءة: البطاقة تحمل بيانات.',
  'adp.hold.encode_unknown': 'نتيجة الترميز غير معروفة',
  'adp.hold.read_back_unknown': 'نتيجة إعادة القراءة غير معروفة',
  'adp.channel.stable': 'مستقرة',
  'adp.channel.pilot': 'تجريبية',
  'adp.manifest.published': 'منشور',
  'adp.manifest.withdrawn': 'مسحوب',
  'adp.transport.http_push': 'إرسال HTTP موقّع',
  'adp.transport.edge_relay': 'ترحيل عبر وكيل طرفي',
  'adp.sourceStatus.active': 'نشط',
  'adp.sourceStatus.disabled': 'معطّل',
  'adp.scale.unit': 'من 0 إلى 1',
  'adp.scale.percent': 'من 0 إلى 100',
  'adp.evOutcome.recorded': 'مسجّل',
  'adp.evOutcome.duplicate': 'مكرر',
  'adp.evOutcome.rejected': 'مرفوض',
  'adp.op.issue': 'إصدار',
  'adp.op.revoke': 'إلغاء',
  'adp.op.read_back': 'إعادة قراءة',
  'adp.op.normalise_read': 'توحيد قراءات اللوحات',
  'adp.op.print': 'طباعة',
  'adp.op.test_page': 'صفحة اختبار',
  'adp.op.encode': 'ترميز',
  'adp.op.capture': 'التقاط',
  'adp.adapter.access.rest-json': 'تحكم دخول REST/JSON عام (passage-access-rest/1)',
  'adp.adapter.anpr.generic-event': 'استقبال عام لأحداث قراءة اللوحات',
  'adp.adapter.printer.sim-edge': 'محاكي طابعة الشارات (وكيل طرفي)',
  'adp.adapter.encoder.sim-edge': 'محاكي جهاز ترميز البطاقات (وكيل طرفي)',
  'adp.adapter.reader.sim-eid-edge': 'محاكي قارئ الهوية الإماراتية (وكيل طرفي)',
  'adp.adapter.reader.sim-mrz-edge': 'محاكي قارئ منطقة القراءة الآلية (وكيل طرفي)',
  'adp.case.manifest.valid': 'بيان بإصدار؛ لا شيء يدّعي الاستخدام في الإنتاج أو اعتماد مورّد.',
  'adp.case.operation.unsupported_explicit': 'العملية غير المدعومة تُرجع نتيجة صريحة بأنها غير مدعومة.',
  'adp.case.operation.timeout_unknown': 'عدم الرد في الوقت نتيجة غير معروفة، وليس نجاحاً أبداً.',
  'adp.case.operation.idempotent_replay': 'التكرار بالمفتاح نفسه لا ينفّذ مرتين.',
  'adp.case.health.separate_from_outcome': 'الاتصال السليم لا يخفي نتيجة فاشلة أو غير معروفة.',
  'adp.case.config.secret_references': 'تُرفض الأسرار النصية؛ تُقبل المراجع فقط.',
  'adp.case.access.issue_read_back': 'بيانات الاعتماد الصادرة تُقرأ مجدداً نشطة بنطاقها.',
  'adp.case.access.duplicate_card_blocked': 'البطاقة المكررة لدى المزوّد توقف التزويد بسبب واضح.',
  'adp.case.access.schedule_restriction_blocked': 'الجدول الذي لا يستطيع المزوّد حفظه يوقف التزويد بسبب واضح.',
  'adp.case.access.revoke_read_back': 'الإلغاء المؤكد يُقرأ مجدداً ملغى.',
  'adp.case.access.server_error_unknown_then_read_back': 'خطأ المزوّد بعد التطبيق نتيجة غير معروفة؛ إعادة القراءة تكشف الحالة الفعلية.',
  'adp.case.access.signed_requests': 'كل طلب موقّع؛ دون السرّ لا يُرسل شيء.',
  'adp.case.anpr.low_confidence_preserved': 'الثقة المنخفضة تبقى منخفضة.',
  'adp.case.anpr.clock_skew_flagged': 'ساعة الكاميرا المنحرفة توسم ولا تُحتسب قراءة حالية واثقة أبداً.',
  'adp.case.anpr.jurisdiction_normalised': 'توحيد رموز الدولة والإمارة.',
  'adp.case.anpr.invalid_rejected': 'تُرفض الأحداث غير الصالحة ولا تُخمّن.',
  'adp.case.printer.jam_not_success': 'المهمة العالقة ليست طباعة ناجحة.',
  'adp.case.encoder.no_custody_or_credential': 'الترميز لا يغيّر الحيازة ولا بيانات الاعتماد.',
  'adp.case.encoder.read_back_after_unknown': 'بعد انتهاء مهلة جهاز الترميز، تكشف إعادة القراءة ما تحمله البطاقة.',
  'adp.case.reader.firmware_unvalidated': 'البرنامج الثابت غير المعروف يوسم بأنه غير معتمد.',
  'adp.case.reader.output_is_evidence_only': 'مخرجات القارئ دليل للمراجعة، وليست هوية متحققاً منها أبداً.',
  'adp.ui.edge.signedWith': 'موقّع بـ {key}',
  'adp.reason.paper_jam': 'أبلغت الطابعة عن انحشار الورق.',
  'adp.reason.card_not_present': 'لا توجد بطاقة في جهاز الترميز.',
  'adp.reason.reader_error': 'أبلغ القارئ عن خطأ.',
  'adp.reason.printer_no_confirmation': 'لم تؤكد الطابعة.',
  'adp.reason.write_unverified': 'تعذّر على جهاز الترميز تأكيد الكتابة.',
  'adp.reason.device_timeout': 'لم يرد الجهاز في الوقت المحدد.',
  'adp.reason.device_error': 'فشل برنامج تشغيل الجهاز.',
  'adp.reason.peripheral_missing': 'الجهاز غير متصل بالوكيل.',
  'adp.reason.unsupported_command': 'لا يدعم الوكيل هذا الأمر.',
  'adp.reason.expired': 'كانت صلاحية الأمر قد انتهت.',
  'adp.reason.replayed': 'كان الأمر قد استُخدم من قبل.',
  'adp.reason.wrong_site': 'ذكر الأمر موقعاً آخر.',
  'adp.reason.capability_not_allowed': 'غير مسموح لهذا الجهاز بذلك.',
  'adp.reason.peripheral_unknown': 'الجهاز غير مسموح به على هذا الوكيل.',
  'adp.reason.ttl_too_long': 'مدة صلاحية الأمر غير مقبولة.',
  'adp.reason.not_yet_valid': 'لم يكن الأمر صالحاً بعد.',
  'adp.reason.capability_mismatch': 'لم يطابق الأمر قدرته.',
  'adp.reason.bad_version': 'صيغة أمر غير معروفة.',
  'adp.reason.observed_in_future': 'القراءة بعيدة جداً في المستقبل.',
  'adp.reason.confidence_out_of_range': 'قيمة الثقة خارج النطاق.',
  'adp.reason.source_missing': 'الحدث المرحّل لا يذكر مصدراً.',
  'adp.reason.source_disabled': 'المصدر معطّل.',
  'adp.reason.entitlement_required': 'قراءة اللوحات غير مفعّلة للمؤسسة.',
  'adp.reason.read_back_invalid': 'تعذّر استخدام رد إعادة القراءة.',
  'adp.reason.cancelled_before_delivery': 'أُلغي قبل أن يستلمه أي وكيل.',
};
